//#region types
import { StyleEnums } from "models/enums";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
import { UnhandledInfoBannerProps } from "models/propTypes/incomingInvoicePropTypes";
//#endregion
//#region components
import { Grid } from "@mui/material";
import { Banner } from "components/common";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const UnhandledInfoBanner: React.FC<UnhandledInfoBannerProps> = ({
  hidden,
}) => {
  if (hidden) return <></>;

  return (
    <Banner
      title={LocalizationHelperInstance.getFormattedMessage(
        TranslationKeys.IncomingInvoice.UnhandledInfoBannerTitle
      )}
      icon={IconDefinitionConstants.WInfo}
      type={StyleEnums.DisplayType.Info}
    >
      <Grid container direction="column" spacing={2}>
        <Grid item>
          {LocalizationHelperInstance.getFormattedMessage(
            TranslationKeys.IncomingInvoice.UnhandledInfoBannerText
          )}
        </Grid>
      </Grid>
    </Banner>
  );
};

export default UnhandledInfoBanner;
